import { BlockContainer } from '@/components/ui/BlockContainer'
import { Title } from '@/components/ui/Title'
import { classes } from '@lc/libreact'
import type { ReactNode } from 'react'
import { Grid } from './Grid'
import styles from './GridContainer.scss'

export function GridContainer({
	children,
	className,
	innerClassName,
	shadow,
	title,
	columns,
}: {
	children: ReactNode
	className?: string
	innerClassName?: string
	shadow?: boolean
	title?: { title: string; color: 'light' | 'primary' | 'black' }
	columns: number
}) {
	return (
		<section className={classes(styles.container, className)}>
			<Title
				className={styles.title}
				title={title?.title ?? ''}
				level={'h3'}
				color={title ? title.color : 'light'}
			/>
			<BlockContainer shadow={shadow}>
				<Grid
					children={children}
					columns={columns}
					innerClassName={innerClassName}
				/>
			</BlockContainer>
		</section>
	)
}
